// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Aboutus_body__H6KGT{
    overflow: hidden;
}
button {
    cursor: pointer;
}
.Aboutus_outerOne__ZG2LK{
    position: relative;
    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.7)), url(https://4kwallpapers.com/images/walls/thumbs_3t/8324.png);
    background-size: cover;
    background-position: center;
    height: 91vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.Aboutus_innerOne__m0LSG{
    position: absolute;
    text-align: center;
    max-width: 800px;
    padding: 20px;
}
.Aboutus_innerHeading__f8YnE{
    font-size: 3rem;
    line-height: 1;
    color: white;
    margin-bottom: 1rem;
}
.Aboutus_innerPara__1J\\+Mu{
    color: white;
    font-size: 1.25rem;
    line-height: 1.75rem;
    margin-bottom: 2rem;
}
.Aboutus_startListning__\\+B29K{
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
    padding: 0.75rem 1.5rem;
    border-color:  rgb(220 38 38 / var(--tw-border-opacity, 1));
    font-weight: 700;
    border-radius: 0.5rem;
    color: white;
    margin-right: 10px; 
}
.Aboutus_exploreStories__-HJ3k{
    color: white;
    border-width: 1px;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
    border-radius: 0.5rem;
    background-color: transparent;
    background-image: none;
    padding: 0.75rem 1.5rem;
    font-weight: 700;
}
/*secondSection*/
.Aboutus_secondSection__T\\+MOQ{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 3rem;
    margin-top: 4rem;
    width: 90%;
}
.Aboutus_experience__INcdf{
    color: white;
    font-size: 2.25rem;
    line-height: 2.5rem;
    font-weight: 700;
    font-family: Poppins, sans-serif, system-ui, sans-serif;
}
.Aboutus_redDiv__FPrfX{
    background-image: radial-gradient(circle at 55% 226%, rgb(255 0 0 / 57%), transparent);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 1rem;
    inset: 0px;
    text-align: center;
    padding: 81px 50px;
 }
.Aboutus_redCirclediv__NUVF3{
    background-color: rgb(220 38 38 / 0.2);
    border-radius: 9999px;
    margin-left: auto;
    margin-right: auto;
    width: 6rem;
    height: 6rem;
 }
 .Aboutus_audioStories__qXRV2{
    color: white;
    font-size: 1.25rem;
    line-height: 0.1rem;
    font-weight: 700;
    font-family: Poppins, sans-serif, system-ui, sans-serif;
}
.Aboutus_insideIcon__iqKA4{
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
    width: 88px;
    height: 59px;
    padding: 16px 0px;
}
.Aboutus_immersePara__0d\\+-U{
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.Aboutus_secondSectionBox__VVCaU{
    padding: 20px 50px;
}
.Aboutus_ourMission__3yW8N {
    padding-top: 2rem;
    max-width: 1200px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: auto;
}
.Aboutus_ourMissionhead__2rbce {
    color: #ffffff;
    margin-bottom: 1rem;
    font-size: 2rem;
}
.Aboutus_outDiv__5qNDc{
    text-align: center;
}
.Aboutus_borderBottom__8saTB{
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
    width: 5rem;
    height: 0.25rem;
    margin-left: auto;
    margin-right: auto;
}
.Aboutus_gridBoxes__nQxzV {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4.8rem;
    margin-top: 4rem;
    max-width: 1150px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 4rem;
  }
.Aboutus_gridDiv__3wQkb {
    background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
    border-radius: 0.5rem;
    padding: 1.6rem;
}
.Aboutus_redCircledivlit__tWNlU{
    background-color: rgb(220 38 38 / 0.2);
    border-radius: 9999px;
    width: 4rem;
    height: 4rem;
 }
.Aboutus_insideIconlit__Q72nw{
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
    width: 61px;
    height: 32px;
    padding: 16px 0px;
}
.Aboutus_ourMissionouter__pFuuV{
    background-image:  linear-gradient(rgb(171 171 171 / 10%), rgba(0, 0, 0, 0.5)),url('https://img.freepik.com/free-photo/grunge-black-concrete-textured-background_53876-124541.jpg?semt=ais_hybrid');
    background-size: cover;
    background-attachment: fixed;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.Aboutus_ourMissionlit__EyRMT{
    text-align: center;
    margin-top: 3rem;
    max-width: 1200px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: auto;
}
.Aboutus_getIntouch__hlZZL{
    display: grid;

}

/* Responsive Styles */
@media screen and (max-width: 1024px) {
    .Aboutus_gridBoxes__nQxzV {
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }
    .Aboutus_secondSection__T\\+MOQ {
      grid-template-columns: 1fr;
      text-align: center;
    }
  }
  
  @media screen and (max-width: 768px) {
    .Aboutus_innerHeading__f8YnE {
        font-size: 2.5rem;
    }
    .Aboutus_innerPara__1J\\+Mu {
        font-size: 1rem;
    }
    .Aboutus_gridBoxes__nQxzV {
        grid-template-columns: repeat(1, 1fr);
        gap: 1.5rem;
    }
    .Aboutus_redDiv__FPrfX {
        padding: 30px;
    }
    .Aboutus_buttonGroup__9Kmfn {
        flex-direction: column;
    }
}

@media screen and (max-width: 480px) {
    .Aboutus_innerHeading__f8YnE {
        font-size: 2rem;
    }
    .Aboutus_innerPara__1J\\+Mu {
        font-size: 0.9rem;
    }
    .Aboutus_buttonGroup__9Kmfn button {
        width: 100%;
        margin-bottom: 0.5rem;
    }
    .Aboutus_gridDiv__3wQkb {
        padding: 1rem 0rem;
    }
    .Aboutus_redDiv__FPrfX {
        margin-left: 3rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Aboutus/Aboutus.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,wIAAwI;IACxI,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,0DAA0D;IAC1D,uBAAuB;IACvB,2DAA2D;IAC3D,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,0DAA0D;IAC1D,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;AACA,gBAAgB;AAChB;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uDAAuD;AAC3D;AACA;IACI,sFAAsF;IACtF,4EAA4E;IAC5E,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;CACrB;AACD;IACI,sCAAsC;IACtC,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf;CACA;IACG,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uDAAuD;AAC3D;AACA;IACI,iDAAiD;IACjD,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mDAAmD;AACvD;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,0DAA0D;IAC1D,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;IACI,yDAAyD;IACzD,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,sCAAsC;IACtC,qBAAqB;IACrB,WAAW;IACX,YAAY;CACf;AACD;IACI,iDAAiD;IACjD,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mMAAmM;IACnM,sBAAsB;IACtB,4BAA4B;IAC5B,wCAAwC;AAC5C;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,aAAa;;AAEjB;;AAEA,sBAAsB;AACtB;IACI;MACE,qCAAqC;MACrC,SAAS;IACX;IACA;MACE,0BAA0B;MAC1B,kBAAkB;IACpB;EACF;;EAEA;IACE;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,qCAAqC;QACrC,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".body{\n    overflow: hidden;\n}\nbutton {\n    cursor: pointer;\n}\n.outerOne{\n    position: relative;\n    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.7)), url(https://4kwallpapers.com/images/walls/thumbs_3t/8324.png);\n    background-size: cover;\n    background-position: center;\n    height: 91vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.innerOne{\n    position: absolute;\n    text-align: center;\n    max-width: 800px;\n    padding: 20px;\n}\n.innerHeading{\n    font-size: 3rem;\n    line-height: 1;\n    color: white;\n    margin-bottom: 1rem;\n}\n.innerPara{\n    color: white;\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n    margin-bottom: 2rem;\n}\n.startListning{\n    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));\n    padding: 0.75rem 1.5rem;\n    border-color:  rgb(220 38 38 / var(--tw-border-opacity, 1));\n    font-weight: 700;\n    border-radius: 0.5rem;\n    color: white;\n    margin-right: 10px; \n}\n.exploreStories{\n    color: white;\n    border-width: 1px;\n    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));\n    border-radius: 0.5rem;\n    background-color: transparent;\n    background-image: none;\n    padding: 0.75rem 1.5rem;\n    font-weight: 700;\n}\n/*secondSection*/\n.secondSection{\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 3rem;\n    margin-top: 4rem;\n    width: 90%;\n}\n.experience{\n    color: white;\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n    font-weight: 700;\n    font-family: Poppins, sans-serif, system-ui, sans-serif;\n}\n.redDiv{\n    background-image: radial-gradient(circle at 55% 226%, rgb(255 0 0 / 57%), transparent);\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    border-radius: 1rem;\n    inset: 0px;\n    text-align: center;\n    padding: 81px 50px;\n }\n.redCirclediv{\n    background-color: rgb(220 38 38 / 0.2);\n    border-radius: 9999px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 6rem;\n    height: 6rem;\n }\n .audioStories{\n    color: white;\n    font-size: 1.25rem;\n    line-height: 0.1rem;\n    font-weight: 700;\n    font-family: Poppins, sans-serif, system-ui, sans-serif;\n}\n.insideIcon{\n    color: rgb(239 68 68 / var(--tw-text-opacity, 1));\n    width: 88px;\n    height: 59px;\n    padding: 16px 0px;\n}\n.immersePara{\n    color: rgb(163 163 163 / var(--tw-text-opacity, 1));\n}\n.secondSectionBox{\n    padding: 20px 50px;\n}\n.ourMission {\n    padding-top: 2rem;\n    max-width: 1200px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    margin: auto;\n}\n.ourMissionhead {\n    color: #ffffff;\n    margin-bottom: 1rem;\n    font-size: 2rem;\n}\n.outDiv{\n    text-align: center;\n}\n.borderBottom{\n    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));\n    width: 5rem;\n    height: 0.25rem;\n    margin-left: auto;\n    margin-right: auto;\n}\n.gridBoxes {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 4.8rem;\n    margin-top: 4rem;\n    max-width: 1150px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 4rem;\n  }\n.gridDiv {\n    background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));\n    border-radius: 0.5rem;\n    padding: 1.6rem;\n}\n.redCircledivlit{\n    background-color: rgb(220 38 38 / 0.2);\n    border-radius: 9999px;\n    width: 4rem;\n    height: 4rem;\n }\n.insideIconlit{\n    color: rgb(239 68 68 / var(--tw-text-opacity, 1));\n    width: 61px;\n    height: 32px;\n    padding: 16px 0px;\n}\n.ourMissionouter{\n    background-image:  linear-gradient(rgb(171 171 171 / 10%), rgba(0, 0, 0, 0.5)),url('https://img.freepik.com/free-photo/grunge-black-concrete-textured-background_53876-124541.jpg?semt=ais_hybrid');\n    background-size: cover;\n    background-attachment: fixed;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.ourMissionlit{\n    text-align: center;\n    margin-top: 3rem;\n    max-width: 1200px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    margin: auto;\n}\n.getIntouch{\n    display: grid;\n\n}\n\n/* Responsive Styles */\n@media screen and (max-width: 1024px) {\n    .gridBoxes {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 2rem;\n    }\n    .secondSection {\n      grid-template-columns: 1fr;\n      text-align: center;\n    }\n  }\n  \n  @media screen and (max-width: 768px) {\n    .innerHeading {\n        font-size: 2.5rem;\n    }\n    .innerPara {\n        font-size: 1rem;\n    }\n    .gridBoxes {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 1.5rem;\n    }\n    .redDiv {\n        padding: 30px;\n    }\n    .buttonGroup {\n        flex-direction: column;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .innerHeading {\n        font-size: 2rem;\n    }\n    .innerPara {\n        font-size: 0.9rem;\n    }\n    .buttonGroup button {\n        width: 100%;\n        margin-bottom: 0.5rem;\n    }\n    .gridDiv {\n        padding: 1rem 0rem;\n    }\n    .redDiv {\n        margin-left: 3rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `Aboutus_body__H6KGT`,
	"outerOne": `Aboutus_outerOne__ZG2LK`,
	"innerOne": `Aboutus_innerOne__m0LSG`,
	"innerHeading": `Aboutus_innerHeading__f8YnE`,
	"innerPara": `Aboutus_innerPara__1J+Mu`,
	"startListning": `Aboutus_startListning__+B29K`,
	"exploreStories": `Aboutus_exploreStories__-HJ3k`,
	"secondSection": `Aboutus_secondSection__T+MOQ`,
	"experience": `Aboutus_experience__INcdf`,
	"redDiv": `Aboutus_redDiv__FPrfX`,
	"redCirclediv": `Aboutus_redCirclediv__NUVF3`,
	"audioStories": `Aboutus_audioStories__qXRV2`,
	"insideIcon": `Aboutus_insideIcon__iqKA4`,
	"immersePara": `Aboutus_immersePara__0d+-U`,
	"secondSectionBox": `Aboutus_secondSectionBox__VVCaU`,
	"ourMission": `Aboutus_ourMission__3yW8N`,
	"ourMissionhead": `Aboutus_ourMissionhead__2rbce`,
	"outDiv": `Aboutus_outDiv__5qNDc`,
	"borderBottom": `Aboutus_borderBottom__8saTB`,
	"gridBoxes": `Aboutus_gridBoxes__nQxzV`,
	"gridDiv": `Aboutus_gridDiv__3wQkb`,
	"redCircledivlit": `Aboutus_redCircledivlit__tWNlU`,
	"insideIconlit": `Aboutus_insideIconlit__Q72nw`,
	"ourMissionouter": `Aboutus_ourMissionouter__pFuuV`,
	"ourMissionlit": `Aboutus_ourMissionlit__EyRMT`,
	"getIntouch": `Aboutus_getIntouch__hlZZL`,
	"buttonGroup": `Aboutus_buttonGroup__9Kmfn`
};
export default ___CSS_LOADER_EXPORT___;
